export const DistrictData = `
    id
    code
    name
    city
    isActive
    lastModifiedAt
`;
